import React, { useState, useEffect } from 'react';
import '../../../styles/trangchu.scss';
import ThongKe from './thongke';
import Grid from '@mui/material/Grid';
import BieuDoCot from './bieudocot';
import BieuDoTron from './bieudotron';
import Bieudoduong from './bieudoduong';
import Api from '../../../api2';
import ThongKeDTM from './thongkedtm';
import ThongKeGP from './thongkegp';
import ThongKeDiemQuanTrac from './diemquantrac';
import ThongKeTramQuanTrac from './thongketramquantrac';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import CircularProgress from '@mui/material/CircularProgress';
import LinearProgress from '@mui/material/LinearProgress';
import Box from '@mui/material/Box';
import { MyButton } from '../../Lib/componentLibrarys';
import anhTrangChu from '../../../assets/images/backgroundTrangChu.jpg'
export default function TrangChu() {
    return (
        <div className="body-trangchu">
            <img src={anhTrangChu}></img>
        </div>
    );
}
